import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import DOMPurify from "dompurify";
import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import ColorScale from '_class/ColorScale';
import { Collapsible } from 'UI';
/* Compontent for displaying blocks from a Matrix */

var MatrixDisplayBlock = /*#__PURE__*/function (_Component) {
  _inherits(MatrixDisplayBlock, _Component);

  var _super = _createSuper(MatrixDisplayBlock);

  function MatrixDisplayBlock(props) {
    var _this;

    _classCallCheck(this, MatrixDisplayBlock);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "openClarifications", function () {
      var openClarifications = _this.state.openClarifications;
      openClarifications = openClarifications ? false : true;

      _this.setState({
        openClarifications: openClarifications
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleIcon", function () {
      return /*#__PURE__*/React.createElement("i", {
        className: "cl-container"
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        className: _this.state.openClarifications ? "a-180" : null,
        style: {
          height: "7px",
          width: "15px"
        }
      }, /*#__PURE__*/React.createElement("path", {
        id: "Path_50",
        "data-name": "Path 50",
        className: "cls-1",
        d: "M11.361,1.4,6.38,5.9,1.4,1.4"
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderClarifications", function () {
      return _this.props.associatedBlock.clarifications.map(function (clarification, i) {
        return /*#__PURE__*/React.createElement("div", {
          className: "demand",
          key: "demand-" + i
        }, /*#__PURE__*/React.createElement("div", {
          className: "title-container"
        }, /*#__PURE__*/React.createElement("span", {
          className: "title",
          dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(clarification.text)
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "steps-container"
        }, clarification.cells.map(function (cell, i) {
          return /*#__PURE__*/React.createElement("div", {
            className: "step",
            key: "step-" + i,
            dangerouslySetInnerHTML: {
              __html: DOMPurify.sanitize(cell.text)
            }
          });
        })), /*#__PURE__*/React.createElement("div", {
          style: {
            clear: "both"
          }
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "descriptionStepSelected", function (step) {
      if (_this.props.assessments != null) {
        var assessment = _this.props.assessments.find(function (t) {
          return t.studentId == _this.props.currentUser.userId;
        });

        if (assessment != null) {
          var detail = null;

          if (assessment.assessmentDetails != null && assessment.assessmentDetails.length > 0) {
            detail = assessment.assessmentDetails.find(function (t) {
              return t.rowId == _this.props.block.id && t.cellId == step.id;
            });
          }

          if (detail != null) {
            return true;
          }
        }
      }

      return false;
    });

    _this.state = {
      openClarifications: false
    };
    return _this;
  }

  _createClass(MatrixDisplayBlock, [{
    key: "getGrade",
    value: function getGrade(index) {
      var type = this.props.type;

      if (type == "single") {
        index = index + 1;
      }

      if (index == 0) {
        return "F";
      } else if (index == 1) {
        return "E";
      } else if (index == 2) {
        return "C";
      } else if (index == 3) {
        return "A";
      } else {
        return "A";
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var associatedBlock = this.props.associatedBlock;
      var colors = new ColorScale(this.props.block.cells.length).get();
      var highestGrade = "";

      if (this.props.assessments != null) {
        var assessment = this.props.assessments.find(function (t) {
          return t.studentId == _this2.props.currentUser.userId;
        });

        if (assessment != null) {
          var detail = null;

          if (assessment.assessmentDetails != null && assessment.assessmentDetails.length > 0) {
            detail = assessment.assessmentDetails.find(function (t) {
              return t.rowId == _this2.props.block.id;
            });
          } else if (assessment.studentAssessmentDetails != null && assessment.studentAssessmentDetails.length > 0) {
            detail = assessment.studentAssessmentDetails.find(function (t) {
              return t.rowId == _this2.props.block.id;
            });
          }

          if (detail != null) {
            highestGrade = detail.cellId;
          }
        }
      }

      var foundGrade = false;
      var clarificatonTrigger = this.props.translate('Clarifications');

      if (associatedBlock.clarifications.length > 0) {
        clarificatonTrigger += ' (' + associatedBlock.clarifications.length + ')';
      }

      return /*#__PURE__*/React.createElement("div", {
        className: this.props.sentenceNr != null ? this.props.sentenceNr == 1 ? "matrix-block pragraph" : "matrix-block" : "matrix-block",
        key: this.props.block.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "matrix-block-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "matrix-block-title"
      }, this.props.index ? /*#__PURE__*/React.createElement("span", null, this.props.index, "\xA0") : null, this.props.block != null && this.props.block.text != null ? /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: this.props.block.text.replace(new RegExp("\r\n", "g"), "<br />")
        }
      }) : /*#__PURE__*/React.createElement("span", null)), /*#__PURE__*/React.createElement("div", {
        className: "matrix-block-steps"
      }, this.props.block.cells.map(function (step, index) {
        var grade = _this2.getGrade(index);

        if (_this2.props.type == "multiple") {
          if (highestGrade != "") {
            if (grade == highestGrade && foundGrade == false) {
              foundGrade = true;
              step.selected = true;
            } else if (highestGrade == step.id && foundGrade == false) {
              foundGrade = true;
              step.selected = true;
            } else if (grade != highestGrade && foundGrade == false && grade != "F") {
              step.selected = true;
            }
          } else {
            step.selected = false;
          }
        } else if (_this2.props.type == "single") {
          step.selected = _this2.descriptionStepSelected(step);
        } else {
          step.selected = false;
        }

        return /*#__PURE__*/React.createElement("div", {
          className: step.selected ? "matrix-block-step selected" : "matrix-block-step",
          style: {
            "--level-color": colors[index]
          },
          key: step.id + '-' + index
        }, /*#__PURE__*/React.createElement("div", {
          className: "matrix-block-step-description"
        }, step.text));
      }, this))), associatedBlock.clarifications != null && associatedBlock.clarifications.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "matrix-block-clarifications"
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: clarificatonTrigger
      }, /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, this.renderClarifications()))) : null);
    }
  }]);

  return MatrixDisplayBlock;
}(Component);

function mapStateToProps(state) {
  return {
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(MatrixDisplayBlock);